import { Flex, IconArrowRight, Stack, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import {
  FieldGroupBox,
  IconPercent,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  RuleStack,
  Tag,
  useFormStateContext,
} from 'ui'
import { ProgressiveDiscountEffect } from '../../../../../../typings'
import { messages } from '../messages'
import styles from '../styles'
import { useNumbers } from 'ui/components/utils/useNumbers'

type Props = {
  name: string
  onRemove: () => void
  onEdit: () => void
}

const renderTag = (content) => <Tag>{content}</Tag>

export function ViewBenefit(props: Props) {
  const { name, onRemove, onEdit } = props
  const { form } = useFormStateContext()
  const { $t } = useIntl()
  const { formatPercentual } = useNumbers()

  const {
    benefit,
    trigger: { sameItemsOnly },
  }: NonNullableObject<ProgressiveDiscountEffect> = useWatch({ form, name })

  return (
    <Flex direction="column" className={styles.filledBox}>
      <Text>
        {$t(messages.benefit.description, {
          tag: renderTag,
        })}
      </Text>
      <FieldGroupBox name={`${name}.benefit`} withBorder={false}>
        <RuleStack>
          <Rule onClick={onEdit}>
            <RuleIcon>
              <IconPercent />
            </RuleIcon>
            <RuleDescription>
              {$t(messages.benefit.percentualTitle, {
                b: (content) => <Text variant="body">{content}</Text>,
                sameItemsOnly,
              })}
            </RuleDescription>
            <RuleContent>
              <Stack space="$space-1">
                {benefit.map(({ quantity, discount }, index) => (
                  <span key={index} className={styles.discountContainer}>
                    {$t(messages.benefit.itemAndDiscount, {
                      discount: formatPercentual(discount),
                      quantity,
                      tag: renderTag,
                      arrowRightIcon: <IconArrowRight size="small" />,
                    })}
                  </span>
                ))}
              </Stack>
            </RuleContent>
            <RuleActions>
              <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
            </RuleActions>
          </Rule>
        </RuleStack>
      </FieldGroupBox>
    </Flex>
  )
}
